import { createSvgComponent } from "../../icon/createSvgComponent";
import ArrowDownLine from "@core/__generated__/icon/figma/arrow-down-line.svg";
export default createSvgComponent(ArrowDownLine);